import moment from 'moment';
import { FETCH_VEHICLES_WITH_DRIVE_TIME, RESET_COMPANY_CONTEXT } from '../../actions';

const vehiclesWithDriveTimeInitState = {
  loading: false,
  error: null,
  lastUpdated: moment(),
  data: [],
  idSet: new Set(),
};

export function vehiclesWithDriveTimeReducer(
  state = vehiclesWithDriveTimeInitState,
  { type, payload, meta },
) {
  switch (type) {
    case FETCH_VEHICLES_WITH_DRIVE_TIME.SUCCESS: {
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      const ids = payload.data.vehicleIdsWithDriveTime || [];
      return {
        ...state,
        data: ids,
        idSet: new Set(ids),
        loading: false,
        error: null,
        lastUpdated: moment(),
      };
    }
    case FETCH_VEHICLES_WITH_DRIVE_TIME.FAIL:
      if (state.actionId !== meta.previousAction.payload.actionId) {
        return state;
      }
      // Preserve previous data on transient errors to avoid flickering link visibility.
      return {
        ...state, loading: false, error: payload, lastUpdated: moment(),
      };
    case FETCH_VEHICLES_WITH_DRIVE_TIME.START:
      return { ...state, loading: true, actionId: payload.actionId };
    case RESET_COMPANY_CONTEXT:
      return { ...vehiclesWithDriveTimeInitState };
    default:
      return state;
  }
}
